import React from 'react';
import Typography from '@mui/material/Typography';

const ComponentHeaderTitles = ({ title }) => {
    return (
        <div class="component-header-titles">
        <h2> {title} </h2>
    </div>
    );
}

export default ComponentHeaderTitles;